/* tslint:disable */
/* eslint-disable */
/**
 * User service API
 * Service for user management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AidResponseDto,
  UserEmailDto,
} from '../models/index';
import {
    AidResponseDtoFromJSON,
    AidResponseDtoToJSON,
    UserEmailDtoFromJSON,
    UserEmailDtoToJSON,
} from '../models/index';

export interface Delete1Request {
    userId: string;
    email: string;
}

export interface GetUserEmailsRequest {
    userId: string;
}

export interface GetUserOriginAidByEmailRequest {
    email: string;
}

export interface NewEmailRequest {
    userEmailDto: UserEmailDto;
}

/**
 * 
 */
export class EmailControllerApi extends runtime.BaseAPI {

    /**
     * Delete user email
     */
    async delete1Raw(requestParameters: Delete1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling delete1().'
            );
        }

        if (requestParameters['email'] == null) {
            throw new runtime.RequiredError(
                'email',
                'Required parameter "email" was null or undefined when calling delete1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/user-mgmt/email/{user_id}/{email}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['userId']))).replace(`{${"email"}}`, encodeURIComponent(String(requestParameters['email']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete user email
     */
    async delete1(requestParameters: Delete1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.delete1Raw(requestParameters, initOverrides);
    }

    /**
     * Get user emails
     */
    async getUserEmailsRaw(requestParameters: GetUserEmailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserEmailDto>>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling getUserEmails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/user-mgmt/email/{user_id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserEmailDtoFromJSON));
    }

    /**
     * Get user emails
     */
    async getUserEmails(requestParameters: GetUserEmailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserEmailDto>> {
        const response = await this.getUserEmailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Needed while onboarding, that\'s why it is public
     * Get origin aid by email
     * @deprecated
     */
    async getUserOriginAidByEmailRaw(requestParameters: GetUserOriginAidByEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AidResponseDto>> {
        if (requestParameters['email'] == null) {
            throw new runtime.RequiredError(
                'email',
                'Required parameter "email" was null or undefined when calling getUserOriginAidByEmail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/user-mgmt/email/origin-aid/{email}`.replace(`{${"email"}}`, encodeURIComponent(String(requestParameters['email']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AidResponseDtoFromJSON(jsonValue));
    }

    /**
     * Needed while onboarding, that\'s why it is public
     * Get origin aid by email
     * @deprecated
     */
    async getUserOriginAidByEmail(requestParameters: GetUserOriginAidByEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AidResponseDto | null | undefined > {
        const response = await this.getUserOriginAidByEmailRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * Create new email
     */
    async newEmailRaw(requestParameters: NewEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserEmailDto>>> {
        if (requestParameters['userEmailDto'] == null) {
            throw new runtime.RequiredError(
                'userEmailDto',
                'Required parameter "userEmailDto" was null or undefined when calling newEmail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/user-mgmt/email/new`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserEmailDtoToJSON(requestParameters['userEmailDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserEmailDtoFromJSON));
    }

    /**
     * Create new email
     */
    async newEmail(requestParameters: NewEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserEmailDto>> {
        const response = await this.newEmailRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
